import { useMutation, MutationFunction } from '@apollo/client';
import { useNotifications } from '@sixfold/common-ui';
import { Children, renderChildren } from '@sixfold/typed-render-props';
import { gql } from 'graphql-tag';
import React from 'react';

import {
  AddCompanyTagMutation as AddCompanyTagMutationResult,
  AddCompanyTagMutationVariables,
  RemoveCompanyTagMutation as RemoveCompanyTagMutationResult,
  RemoveCompanyTagMutationVariables,
} from '../../lib/graphql';
import { companyQuery } from '../graphql';

const addCompanyTagMutation = gql`
  mutation AddCompanyTag($input: CompanyTagInput!) {
    addCompanyTag(input: $input)
  }
`;

const removeCompanyTagMutation = gql`
  mutation RemoveCompanyTag($input: CompanyTagInput!) {
    removeCompanyTag(input: $input)
  }
`;

interface MutationsProps {
  children?: Children<{
    addCompanyTag: MutationFunction<AddCompanyTagMutationResult, AddCompanyTagMutationVariables>;
    removeCompanyTag: MutationFunction<RemoveCompanyTagMutationResult, RemoveCompanyTagMutationVariables>;
  }>;
}

export const CompanyTagsMutations: React.FC<MutationsProps> = (props) => {
  const notify = useNotifications();
  const [addCompanyTagMutate] = useMutation<AddCompanyTagMutationResult, AddCompanyTagMutationVariables>(
    addCompanyTagMutation,
  );
  const [removeCompanyTagMutate] = useMutation<RemoveCompanyTagMutationResult, RemoveCompanyTagMutationVariables>(
    removeCompanyTagMutation,
  );

  return (
    <>
      {renderChildren(props.children as React.ReactNode, {
        addCompanyTag: async ({ variables }: { variables: AddCompanyTagMutationVariables }) => {
          const response = await addCompanyTagMutate({
            variables,
            refetchQueries: [
              {
                query: companyQuery,
                variables: {
                  company_id: variables.input.companyId,
                  applies_to: 'company',
                },
              },
            ],
          });
          notify.success({ title: 'Company tag added' });
          return response;
        },
        removeCompanyTag: ({ variables }: { variables: RemoveCompanyTagMutationVariables }) => {
          const response = removeCompanyTagMutate({
            variables,
            refetchQueries: [
              {
                query: companyQuery,
                variables: {
                  company_id: variables.input.companyId,
                  applies_to: 'company',
                },
              },
            ],
          });
          notify.success({ title: 'Company tag removed' });
          return response;
        },
      })}
    </>
  );
};
